import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const PKIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="PK" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2F8D00"
        fillRule="evenodd"
        d="M4 0h12v12H4V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h4v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F1F9FF"
        d="M6.29 8.323c-2.34-1.691-.888-5.064.037-5.2 0 0-.89 2.737.881 3.925 1.773 1.187 4.006.605 4.006.605-.341.735-2.583 2.362-4.923.67Zm3.185-4.217 1.087-.497-.581 1.088 1.092.814-1.394-.093-.709 1.04-.17-1.222-1.25-.223 1.186-.58-.07-1.086.809.76Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
